export default __webpack_public_path__ + "static/media/client2.40e0b9b5.jpeg";